import React from 'react';
import './NewsSection.css';

const NewsSection = ({ newsItems = [] }) => {
  if (newsItems.length === 0) return null;

  return (
    <section className="news-section" aria-labelledby="news-section-title">
      <aside className="news-sidebar" aria-label="Latest news and events">
        <h2 id="news-section-title" className="news-sidebar-title">
          Latest News and Events
        </h2>
        <div className="news-items">
          {newsItems.map((item, index) => (
            <article key={index} className="news-item">
              <time className="news-date" dateTime={item.date}>
                {item.dateDisplay}
              </time>
              <p dangerouslySetInnerHTML={{ __html: item.content }} />
            </article>
          ))}
        </div>
      </aside>
    </section>
  );
};

export default NewsSection;

